<template>
  <div :class="(editMode ? 'border border-dashed relative':'') + ' '+ (dashboard.type !== 'dashlet'?
    (dashboard.hasOwnProperty('width') ? ' md:'+dashboard.width :'') : dashboard.width+'  p-2')">
    <div v-if="dashboard.type !== 'dashlet'">
      <div :class="dashboard.type === 'row' ? 'flex flex-row' : (dashboard.type === 'col' ? 'flex flex-col':'' )"
           v-if="dashboard.hasOwnProperty('content') && Array.isArray(dashboard.content)">
        <DashboardSwitcher :edit-mode="editMode" v-for="childDashboard in dashboard.content"
                           :key="childDashboard.id"
                           :org-id="orgId"
                           :filters="filters" :dashboard="childDashboard"/>
      </div>
    </div> 
 
    <AddDashletComponent :configs="filters" v-else-if="dashboard.dashlet === 'add_dashlet'"/>
    <OrganizationSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'org_overview'"/>
    <CampaignSummary :configs="filters" v-else-if="dashboard.dashlet === 'campaign_summary'"/>
    <IndoorHeatmap :org-id="orgId" class="h-full" :filters="filters" v-else-if="dashboard.dashlet === 'heatmap'"/>
    <ApStatus :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'ap_status'"/>
    <AuthModeSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'auth_mode_summary'"/>
    <IsMobileSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'is_mobile_summary'"/>
    <OsSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'os_summary'"/>
    <BrandSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'brand_summary'"/>
    <BrowserSummary :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'browser_summary'"/>
    <TopNetworks :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'top_sites'"/>
    <Connections 
        :org-id="orgId"
        :start-date="filters.dateRange.startDate"
        :end-date="filters.dateRange.endDate"
        :breadcrumb="false" title="Recent connections"
        :authorized="true"
        :rows-per-page="5"
        :venues="venues" v-else-if="dashboard.dashlet === 'connection_summary'"/>
    <Connections
        :org-id="orgId"
        :start-date="filters.dateRange.startDate"
        :end-date="filters.dateRange.endDate"
        :breadcrumb="false"
        title="Currently connected"
        :online="true"
        :venues="venues"
        :rows-per-page="5"
        v-else-if="dashboard.dashlet === 'online_connections'"/> 

    <DwellTime :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'dwell_time'"/>
    <Footfall :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'footfall'"/>
    <ConnectionsGraph :org-id="orgId" :filters="filters" v-else-if="dashboard.dashlet === 'connection_graph'"/>

    <div class="absolute top-0 bg-white flex" :class="dashboard.type === 'dashlet' ? 'm-2 left-0':'right-0'"
         v-if="dashboard.dashlet !== 'add_dashlet' && editMode && (dashboard.type === 'dashlet' || dashboard.type === 'row')">
      <feather v-on:click="updateDashboard('moveup_dashlet',dashboard.id)" v-if="dashboard.type === 'row'"
               type="arrow-up" size="16" class="p-2 border text-blue-500" title="Move up"></feather>
      <feather v-on:click="updateDashboard('movedown_dashlet',dashboard.id)" v-if="dashboard.type === 'row'"
               type="arrow-down" size="16" class="p-2 border text-teal-500" title="Move down"></feather>
      <feather v-on:click="updateDashboard('remove_dashlet',dashboard.id)" type="x" size="16"
               class="p-2 border text-red-500" title="Remove"></feather>
    </div>

  </div>

</template>

<script>
import CampaignSummary from "./CampaignSummary";
import ApStatus from "./ApStatus";
import DwellTime from "./Dwelltime";
import Footfall from "./Footfall";
import OrganizationSummary from "./OrganizationSummary";
import AddDashletComponent from "./AddDashboards/AddDashletComponent";
import ConnectionsGraph from "./ConnectionsGraph";
import Connections from "@/modules/connections/Connections";
import IndoorHeatmap from "@/modules/Dashboards/IndoorHeatmap";
import TopNetworks from "@/modules/Dashboards/TopNetworks";
import AuthModeSummary from "@/modules/Dashboards/AuthModeSummary";
import IsMobileSummary from "@/modules/Dashboards/IsMobileSummary";
import OsSummary from "@/modules/Dashboards/OsSummary";
import BrandSummary from "@/modules/Dashboards/BrandSummary";
import BrowserSummary from "@/modules/Dashboards/BrowserSummary";

export default {
  name: "DashboardSwitcher",
  components: {
    BrowserSummary,
    BrandSummary,
    OsSummary,
    IsMobileSummary,
    AuthModeSummary,
    TopNetworks,
    IndoorHeatmap,
    Connections,
    ConnectionsGraph,
    AddDashletComponent,
    OrganizationSummary,
    Footfall, DwellTime, ApStatus, CampaignSummary
  },
  data() {
    return {
      venues: []
    }
  },
  props: {
    orgId: String,
    dashboard: Object,
    filters: Object,
    editMode: Boolean
  },
  mounted() {
    this.filters.venues.forEach(function (venue) {
      this.venues.push(venue.id);
    });
  },
  methods: {
    updateDashboard(action, id) {
      this.$root.$emit(action, id);
    }
  }
}
</script>

<style scoped>

</style>